<template>
  <aside class="otonami-side-bar bg-gray4 fixed flex h-full min-h-screen w-48 flex-col overflow-y-scroll px-8 py-16">
    <img class="mb-10 w-24" src="@/assets/img/logo.svg" />
    <div class="mb-8 flex-1">
      <ul class="ul">
        <li v-for="list in LISTS" :key="list.label" class="ul__item mb-2">
          <nuxt-link class="no-underline" :to="list.link">{{ list.label }}</nuxt-link>
          <div v-show="list.children" class="mb-2"></div>
          <ul v-if="list.children" class="ul">
            <li v-for="child in list.children" :key="child.label" class="ul__item mb-2 ml-4">
              <nuxt-link class="no-underline" :to="child.link">{{ child.label }}</nuxt-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <footer class="h-32">
      <ul class="ul">
        <li class="mb-2">
          <nuxt-link class="no-underline" to="/payment-notice">支払通知書作成</nuxt-link>
        </li>
        <li class="mb-2">
          <p class="ul__item" @click="onClickLogout">ログアウト</p>
        </li>
      </ul>
    </footer>
  </aside>
</template>

<script setup lang="ts">
import { useAuthKey, type UseAuth } from '@/injectionKeys';

interface SidebarItemChild {
  link: string;
  label: string;
}

interface SidebarItem {
  link: string;
  label: string;
  children?: SidebarItemChild[];
}
const useAuth = inject(useAuthKey) as UseAuth;
const { signOut } = useAuth();

const LISTS: SidebarItem[] = [
  { link: '/providers', label: '事業者' },
  {
    link: '/experiences',
    label: '体験マスタ',
    children: [
      { link: '/locations', label: '場所' },
      { link: '/tags', label: 'タグ' },
      { link: '/experience-options', label: 'オプション' },
    ],
  },
  { link: '/creatives', label: 'クリエイティブマスタ' },
  {
    link: '/experience-event-calendar',
    label: '体験カレンダー',
  },
  {
    link: '/reservations',
    label: '予約',
    children: [
      { link: '/reservation-calendar', label: '予約カレンダー' },
      { link: '/messages', label: 'メッセージ履歴' },
    ],
  },
  { link: '/consumers', label: 'ゲスト' },
  {
    link: '/coupons',
    label: 'クーポン',
    children: [{ link: '/coupons/gifts', label: 'ギフト' }],
  },
  { link: '/coupon-codes', label: 'クーポンコード' },
  { link: '/gift-orders', label: 'ギフト購入履歴' },
  { link: '/campaigns', label: 'キャンペーン' },
  { link: '/experience-notifications', label: '催行通知' },
  {
    link: '/payment-advices',
    label: '事業者実績・支払い通知書(開発中)',
    children: [
      { link: '/payment-advices/bulk', label: '支払通知書一括処理' },
      { link: '/payment-advices/detail', label: '支払通知書詳細' },
    ],
  },
  { link: '/experience-reviews', label: '体験記-投稿一覧' },
];

const router = useRouter();

const onClickLogout = () => {
  signOut()
    .then(() => {
      router.push('/signin');
    })
    .catch(() => {
      alert('ログアウトに失敗しました');
    });
};
</script>

<style lang="scss" scoped>
.router-link-active {
  border-bottom: 3px solid #333; // gray3
}

.otonami-side-bar {
  background-color: #b8c7da;
}
</style>
